export default {
  settings: {
    base_currency: 'BRL',
    enabled_currencies: ['BRL'],
    categories: [],
    payment_methods: []
  }
}
